export default "__VITE_ASSET__b0d789b7__"